import apiClient from './index'

export default {
  async getReleaseNotes() {
    return await apiClient.get('api/release-notes/')
  }
}
